export default "__VITE_ASSET__DG7D3kr4__"